import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, XIcon } from 'lucide-react';
interface Image {
  src: string;
  alt: string;
}
interface ImageGalleryProps {
  images: Image[];
}
export const ImageGallery: React.FC<ImageGalleryProps> = ({
  images
}) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const openLightbox = (index: number) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };
  const closeLightbox = () => {
    setLightboxOpen(false);
  };
  const goToPrevious = () => {
    setCurrentImageIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  const goToNext = () => {
    setCurrentImageIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  return <div data-id="element-169">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-170">
        {images.map((image, index) => <div key={index} className="overflow-hidden rounded-lg cursor-pointer transition-transform duration-300 hover:scale-105" onClick={() => openLightbox(index)} data-id="element-171">
            <img src={image.src} alt={image.alt} className="w-full h-64 object-cover" data-id="element-172" />
          </div>)}
      </div>
      {/* Lightbox */}
      {lightboxOpen && <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center" data-id="element-173">
          <button onClick={closeLightbox} className="absolute top-4 right-4 text-white p-2 rounded-full hover:bg-gray-800 transition" aria-label="Close lightbox" data-id="element-174">
            <XIcon size={24} data-id="element-175" />
          </button>
          <button onClick={goToPrevious} className="absolute left-4 text-white p-2 rounded-full hover:bg-gray-800 transition" aria-label="Previous image" data-id="element-176">
            <ChevronLeftIcon size={32} data-id="element-177" />
          </button>
          <img src={images[currentImageIndex].src} alt={images[currentImageIndex].alt} className="max-h-[80vh] max-w-[90vw] object-contain" data-id="element-178" />
          <button onClick={goToNext} className="absolute right-4 text-white p-2 rounded-full hover:bg-gray-800 transition" aria-label="Next image" data-id="element-179">
            <ChevronRightIcon size={32} data-id="element-180" />
          </button>
        </div>}
    </div>;
};